<template>
  <ShippingRates />
  <DeliveryEstimator v-if="isEDDEnabled" />
  <div class="wysiwyg">
    <p>
      You may return any items from your order within 30 days of receipt using a
      returns label that we can provide or a courier of your choice. With the
      exception of our Level 4 members, customers are expected to cover the cost
      of all returns.
    </p>
  </div>
</template>

<script>
import ShippingRates from "@/components/product-display/ShippingRates.vue";
import DeliveryEstimator from "@/components/product-display/DeliveryEstimator.vue";
import { mapState, mapGetters } from "vuex";
import { regionFeatureToggles } from "@/config.js";

export default {
  name: "ShippingAndReturns",
  components: {
    ShippingRates,
    DeliveryEstimator,
  },
  computed: {
    ...mapState("product", ["product"]),
    ...mapGetters("app", ["currencyCode"]),
    isEDDEnabled() {
      if (this.currencyCode) {
        return regionFeatureToggles[this.currencyCode].eddEnabled || false;
      }
      return false;
    },
  },
};
</script>
